<template>
  <div v-if="$hasFeature('track_trace') && $hasPermission('view_tracking_menu')" class="order-wrapper" v-bind:class="{ 'is-active': openSlideleft, 'theme-dark': isDarkTheme }">
    <portal target-el="#filter">
      <div :class="{'theme-dark-filter': isDarkTheme }">
        <PrimaryFilter
          :menuOptions="trackMenulist"
          :selectedCategory="selectedCategory"
          :noSearchFilter="noSearchFilter"
          :searchParameters="getDashboardSearchConstants"
          :preSearchedParams='searchedParams'
          :enableSearchPopup="true"
          :showPopup="true"
          :searchText="searchText"
          @searchByParameter="searchByParameter"
          :isDarkTheme="isDarkTheme" />
      </div>
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper :values="filterTags" @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
      <div class="flex-item">
        <SwitchBtn v-model="isDarkTheme" class="switch-light" active-text="Dark" inactive-text="Light"
          active-color="#000000" inactive-color="#D9E2E7" />
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content">
        <div class="content">
          <div class="pt-20">
            <Row :gutter="15">
              <TripCount :queryParams="queryParams" :apiTrigger="apiTrigger" :emptyDashboardIcon="emptyDashboardIcon"
                :trackingDashboard="trackingDashboard" @routeToTrack="routeToTrack($event)" v-if="dashboardConfigs && dashboardConfigs.widgets
                 && dashboardConfigs.widgets.track_trip &&
                dashboardConfigs.widgets.track_trip.enable">
              </TripCount>
              <EtaCompliance :etaCompliance="etaresult" :isEtaComplianceLoading="isEtaComplianceLoading"
                :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets &&
                dashboardConfigs.widgets.eta_compliance && dashboardConfigs.widgets.eta_compliance.enable">
              </EtaCompliance>

            </Row>
            <AutoComplete :queryParams="queryParams" :apiTrigger="apiTrigger" :emptyDashboardIcon="emptyDashboardIcon"
              :autoCompleteTripCount="autoCompleteResult" :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets
              && dashboardConfigs.widgets.auto_complete
              && dashboardConfigs.widgets.auto_complete.enable" @routeToTrack="routeToTrack($event)">
            </AutoComplete>

            <TripHalt :queryParams="queryParams" :apiTrigger="apiTrigger"
                :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard"
                :dashboardConfigs="dashboardConfigs" v-if="dashboardConfigs && dashboardConfigs.widgets &&
                dashboardConfigs.widgets.trip_halt_duration
                && dashboardConfigs.widgets.trip_halt_duration.enable" @routeToTrack="routeToTrack($event)">
              </TripHalt>

            <Tracking :queryParams="queryParams" :apiTrigger="apiTrigger" :emptyDashboardIcon="emptyDashboardIcon"
              :trackingDashboard="trackingDashboard" @routeToTrack="routeToTrack($event)" v-if="dashboardConfigs && dashboardConfigs.widgets &&
              dashboardConfigs.widgets.tracking &&
              dashboardConfigs.widgets.tracking.enable">
            </Tracking>

            <Row :gutter="15">

              <Pickups :etaCompliance="etaresult" :isEtaComplianceLoading="isEtaComplianceLoading"
                :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets &&
                dashboardConfigs.widgets.pickups &&
                dashboardConfigs.widgets.pickups.enable" @routeToTrack="routeToTrack($event)">
              </Pickups>

              <DropOffs :etaCompliance="etaresult" :isEtaComplianceLoading="isEtaComplianceLoading"
                :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets &&
                dashboardConfigs.widgets.drop_offs &&
                dashboardConfigs.widgets.drop_offs.enable" @routeToTrack="routeToTrack($event)">
              </DropOffs>

            </Row>

            <PickupVsEta :etaCompliance="etaresult" :isEtaComplianceLoading="isEtaComplianceLoading"
              :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets &&
              dashboardConfigs.widgets.pickup_vs_eta &&
              dashboardConfigs.widgets.pickup_vs_eta.enable">
            </PickupVsEta>

            <DeliveryVsEta :etaCompliance="etaresult" :isEtaComplianceLoading="isEtaComplianceLoading"
              :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets &&
              dashboardConfigs.widgets.delivery_vs_eta &&
              dashboardConfigs.widgets.delivery_vs_eta.enable">
            </DeliveryVsEta>

            <Row :gutter="15">
              <DeliverVsEtaShortHaul :queryParams="queryParams" :apiTrigger="apiTrigger"
                :emptyDashboardIcon="emptyDashboardIcon" :trackingDashboard="trackingDashboard"
                :dashboardConfigs="dashboardConfigs" v-if="dashboardConfigs && dashboardConfigs.widgets &&
                dashboardConfigs.widgets.short_haul_delivery_vs_eta
                && dashboardConfigs.widgets.short_haul_delivery_vs_eta.enable" @routeToTrack="routeToTrack($event)">
              </DeliverVsEtaShortHaul>

              <DeliverVsEtaLongHaul :queryParams="queryParams" :apiTrigger="apiTrigger"
                :emptyDashboardIcon="emptyDashboardIcon" :dashboardConfigs="dashboardConfigs"
                :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets
                && dashboardConfigs.widgets.long_haul_delivery_vs_eta
                && dashboardConfigs.widgets.long_haul_delivery_vs_eta.enable" @routeToTrack="routeToTrack($event)">
              </DeliverVsEtaLongHaul>
            </Row>
            <UnloadingVsEta :queryParams="queryParams" :apiTrigger="apiTrigger" :emptyDashboardIcon="emptyDashboardIcon"
              :trackingDashboard="trackingDashboard" v-if="dashboardConfigs && dashboardConfigs.widgets
              && dashboardConfigs.widgets.unloading_vs_eta
              && dashboardConfigs.widgets.unloading_vs_eta.enable" @routeToTrack="routeToTrack($event)">
            </UnloadingVsEta>
          </div>
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter v-if="!transporterLoading" :selectedFilters="filterConstant" :filters="filters" v-on:search="search"
          v-on:updateOption="updateOption" v-on:reset="resetApply" v-on:clearDate="clearDate" />
      </div>
    </div>
  </div>
  <div v-else class="loading-app page-not-found">
      <h4>Page not found</h4>
      <p>
        Go back to <router-link :to="{ path: '/indents/v2/outbound' }">Indents</router-link>
      </p>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import {
  TrackMenu,
  tripCountHeaders,
  filters,
  getDetailsApiConstants,
  transError,
  dashboardSearchParameters,
} from '@/constants/trackConstants';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import moment from 'moment';
import Vue from 'vue';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import PickupVsEta from '@/components/modules/actions/PickupVsEta';
import DeliveryVsEta from '@/components/modules/actions/DeliveryVsEta.vue';
import DeliverVsEtaShortHaul from '@/components/modules/actions/DeliveryVsEtaShortHaul.vue';
import DeliverVsEtaLongHaul from '@/components/modules/actions/DeliveryVsEtaLongHaul.vue';
import AutoComplete from '@/components/modules/actions/AutoComplete.vue';
import TripHalt from '@/components/modules/actions/TripHalt.vue';
import DropOffs from '@/components/modules/actions/DropOffs.vue';
import Pickups from '@/components/modules/actions/Pickups.vue';
import Tracking from '@/components/modules/actions/Tracking.vue';
import EtaCompliance from '@/components/modules/actions/EtaCompliance.vue';
import TripCount from '@/components/modules/actions/TripCount.vue';
import UnloadingVsEta from '@/components/modules/actions/UnloadingVsEta.vue';
import { trackingDashboard } from 'pando-constants';

export default {
  components: {
    PrimaryFilter,
    SecFilter,
    FilterWrapper,
    PickupVsEta,
    DeliveryVsEta,
    DeliverVsEtaShortHaul,
    DeliverVsEtaLongHaul,
    AutoComplete,
    DropOffs,
    Pickups,
    Tracking,
    EtaCompliance,
    TripCount,
    UnloadingVsEta,
    TripHalt,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      apiTrigger: new Vue(),
      isDarkTheme: true,
      isTripCountLoading: true,
      tripCount: null,
      tripCountHeaders,
      etaCompliance: null,
      dashboardConfigs: null,
      openSlideleft: true,
      defaultValues: {},
      TrackMenu,
      transporterLoading: true,
      isEtaComplianceLoading: true,
      transporterList: [],
      filterConstant: [],
      filters,
      queryParams: null,
      dashboardSearchParameters,
      searchedParams: {},
      searchText: 'Search',
      etaresult: null,
      autoCompleteResult: null,
      trackingDashboard,
      sessionData: null,
    };
  },
  async created() {
    this.loadSearchFromSession();
    this.loadData();
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      depots: 'app/depots',
      otherDepots: 'app/otherDepots',
    }),
    allDepots() {
      const combined = [...(this.depots || []), ...(this.otherDepots || [])];
      const uniqueMap = new Map();
      combined.forEach(depot => {
        if (depot && depot.id && !uniqueMap.has(depot.id)) {
          uniqueMap.set(depot.id, depot);
        }
      });
      return Array.from(uniqueMap.values());
    },
    trackingDetails() {
      let trackingDetails = null;
      if (this.trackDetailsArray && this.trackDetailsArray.length) {
        const simDetails = this.trackDetailsArray.find(val => val.type === 'SIM');
        const appDetails = this.trackDetailsArray.find(val => val.type === 'APP');
        const gpsDetails = this.trackDetailsArray.find(val => val.type === 'GPS');
        if (simDetails) {
          trackingDetails = {
            sim: simDetails.count,
            tracked: simDetails.tracked,
            nontrackable: simDetails.nontrackable,
          };
        }
        if (appDetails) {
          trackingDetails = Object.assign(trackingDetails, {
            app: appDetails.count,
          });
        }
        if (gpsDetails) {
          trackingDetails = Object.assign(trackingDetails, {
            gps: gpsDetails.count,
          });
        }
      }
      return trackingDetails;
    },
    getDashboardSearchConstants() {
      if (
        this.configurations &&
        this.configurations.track_settings &&
        this.configurations.track_settings.dashboard_search_params) {
        return this.configurations.track_settings.dashboard_search_params;
      }
      return [];
    },
    deliveryEtaDetails() {
      return this.etaCompliance && this.etaCompliance.deliveryEta;
    },
    pickupEtaDetails() {
      return this.etaCompliance && this.etaCompliance.pickupEta;
    },
    emptyFillColor() {
      return this.isDarkTheme ? '#253E5B' : '#EEEEEE';
    },
    emptyDashboardIcon() {
      return this.isDarkTheme ? 'empty-dashboard-dark' : 'empty-dashboard-light';
    },
    pickupCompliance() {
      const percentage = this.etaCompliance ? this.etaCompliance.pickup : 0;
      const val = percentage > 0 ? percentage : 0;
      if (this.$refs.pickupComplianceRef) {
        this.$refs.pickupComplianceRef.updateProgress(val);
      }
      return val;
    },

    deliveredCompliance() {
      const percentage = this.etaCompliance ? this.etaCompliance.delivered : 0;
      const val = percentage > 0 ? percentage : 0;
      if (this.$refs.deliveredComplianceRef) {
        this.$refs.deliveredComplianceRef.updateProgress(val);
      }
      return val;
    },
    selectedCategory() {
      return this.TrackMenu.find(menu => menu.id === 'TrackDashboard');
    },
    trackMenulist() {
      return this.TrackMenu.filter(ele => (ele.permission ?
        this.$hasPermission(ele.permission) : true));
    },
    noSearchFilter() {
      if (this.configurations && this.configurations.track_settings &&
        this.configurations.track_settings.enable_dashboard_search &&
        this.configurations.track_settings.dashboard_search_params &&
        this.configurations.track_settings.dashboard_search_params.length > 0
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async loadData() {
      this.transporterLoading = true;
      let result = await this.$store.dispatch('track/transporterList') || [];
      if (result && result.error) {
        result = [];
      }
      if (result) {
        result = result.filter(val => val.id !== transError.MISSING_ID &&
          val.name !== transError.MISSING_NAME);
        result.unshift({ id: -1, name: 'All Transporters', tlabel: 'INDENT_ALL_TRANSPORTER' });
        this.transporterList = result;
      }
      this.transporterLoading = false;
      const oldFilters = localStorage.getItem(`${this.$route.name}-filter`);
      let oldFiltersAvailable = false;
      if (oldFilters && oldFilters.length) {
        this.filterConstant = JSON.parse(oldFilters);
        if (this.filterConstant.length) {
          oldFiltersAvailable = true;
          this.filterConstant[0].map((filter) => {
            if (filter.type === 'List' && filter.category === this.filters.TRANSPORTER) {
              filter.list = this.transporterList;
            }
            if (filter.type === 'MultiSelectList' && filter.category === this.filters.DEPOT) {
              filter.list = this.allDepots;
            }
          });
        }
      }
      if (!oldFiltersAvailable) {
        this.setDefaults();
        this.constructConstantForFilter();
      }
      this.applyFilters();
      this.search();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      const { query, displayLabels } = sessionSearchParams;
      const sessionData = query ? { ...query, displayLabels } : sessionSearchParams;
      this.searchedParams = Object.assign({}, this.searchedParams, sessionData);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.sessionData ? this.sessionData : this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    searchByParameter(params) {
      const { query, displayLabels } = params;
      const sessionData = query ? { ...query, displayLabels } : params;
      this.searchedParams = sessionData;
      this.sessionData = params;
      this.saveSearchToSession();
      this.loadData();
    },

    routeToTrack(event) {
      const header = event.header;
      const category = event.routeCategory;
      if (header.routerActive) {
        const dateRange = this.findByCategory(this.filters.DATE);
        const transporter = this.findByCategory(this.filters.TRANSPORTER);
        const depot = this.findByCategory(this.filters.DEPOT);
        const searchParam = this.serializeObject(this.searchedParams);
        let query = {
          fromDashboard: true,
          start: this.$moment((dateRange.startDate)).startOf('day').toISOString(),
          end: this.$moment((dateRange.endDate)).endOf('day').toISOString(),
        };
        if (transporter && transporter.id && transporter.id !== -1) {
          query = Object.assign(query, { trans: transporter.name, transporterId: transporter.id });
        }
        if (depot && depot.length) {
          query = Object.assign(query, { depotIds: depot.map(d => d.id).join(',') });
        }
        if (category) {
          const obj = {};
          obj[category] = header.routerValue;
          query = Object.assign(query, obj);
        }

        if (header.type) {
          const typeObject = {};
          typeObject.type = header.type;
          query = Object.assign(query, typeObject);
        }
        if (header.routerParent) {
          query = Object.assign(query, header.routerParent);
        }
        if (searchParam) {
          query = Object.assign(query, searchParam);
        }
        this.$router.push({ name: 'Trips', query });
      }
    },
    async fetch(params = null) {
      const queryParams = this.serializeObject(params);

      for (let i = 0; i < getDetailsApiConstants.length; i++) {
        await this.getDetails(getDetailsApiConstants[i].loadingObj,
          getDetailsApiConstants[i].resultObj,
          getDetailsApiConstants[i].section, queryParams);
      }
      this.apiTrigger.$emit('loadMore', {
        data: queryParams,
      });
    },
    async getDetails(loadingObj, resultObj, section, params) {
      if (resultObj === 'dashboardConfigs') {
        this[loadingObj] = true;
        const result = await this.$store.dispatch('track/getDashboardDetails', { section, params });
        if (result && !result.error) {
          this[resultObj] = result;
        } else {
          this[resultObj] = null;
        }
        this[loadingObj] = false;
      }
      if (resultObj === 'etaCompliance') {
        if (this.dashboardConfigs && this.dashboardConfigs.widgets && ((this.dashboardConfigs.widgets.pickups && this.dashboardConfigs.widgets.pickups.enable) ||
          (this.dashboardConfigs.widgets.transit && this.dashboardConfigs.widgets.transit.enable) ||
          (this.dashboardConfigs.widgets.drop_offs && this.dashboardConfigs.widgets.drop_offs.enable) ||
          (this.dashboardConfigs.widgets.pickup_vs_eta && this.dashboardConfigs.widgets.pickup_vs_eta.enable) ||
          (this.dashboardConfigs.widgets.delivery_vs_eta && this.dashboardConfigs.widgets.delivery_vs_eta.enable) ||
          (this.dashboardConfigs.widgets.eta_compliance && this.dashboardConfigs.widgets.eta_compliance.enable))) {
          this[loadingObj] = true;
          this.etaresult = await this.$store.dispatch('track/getDashboardDetails', { section, params });
          if (this.etaresult && !this.etaresult.error) {
            this[resultObj] = this.etaresult;
          } else {
            this[resultObj] = null;
          }
          this[loadingObj] = false;
        }
      }
      if (resultObj === 'autoCompleteTripCount') {
        if (this.dashboardConfigs && this.dashboardConfigs.widgets && this.dashboardConfigs.widgets.auto_complete.enable) {
          this[loadingObj] = true;
          this.autoCompleteResult = await this.$store.dispatch('track/getDashboardDetails', { section, params });
          if (this.autoCompleteResult && !this.autoCompleteResult.error) {
            this[resultObj] = this.autoCompleteResult;
          } else {
            this[resultObj] = null;
          }
          this[loadingObj] = false;
        }
      }
    },
    setDefaults() {
      [this.defaultValues.transporter] = this.transporterList;
      this.defaultValues.depots = this.allDepots;
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = moment().subtract(14, 'days').toString();
    },
    search() {
      this.applyFilters();
      const queryParams = this.constructFilterPayload();
      const searchParam = this.serializeObject(this.searchedParams);
      this.queryParams = Object.assign(queryParams, searchParam);
      this.fetch(queryParams);
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            maxDate: this.defaultValues.endDate,
            start_date_label: 'startDate',
            end_date_label: 'endDate',
            optional: false,
            maxDays: 15,
          },
          {
            type: 'List',
            category: this.filters.TRANSPORTER,
            default: this.defaultValues.transporter,
            selected: this.defaultValues.transporter,
            list: this.transporterList,
            idLabel: 'id',
            queryParamString: 'transporterId',
            optional: false,
            search: true,
          },
          ...(this.allDepots && this.allDepots.length ? [{
            type: 'MultiSelectList',
            category: this.filters.DEPOT,
            default: this.defaultValues.depots,
            selected: this.defaultValues.depots,
            list: this.allDepots,
            idLabel: 'id',
            queryParamString: 'depotIds',
            optional: true,
            selectAllOption: true,
            defaultSelectAll: true,
            allowEmpty: false,
            placeholder: 'Select Depots',
          }] : []),
        ],
      ];
    },
    resetApply() {
      this.resetAll();
      this.search();
    },
    serializeObject(data) {
      const result = {};
      const trackSettings = (this.configurations && this.configurations.track_settings
        && this.configurations.track_settings.custom_fields) || {};
      if (data) {
        const dataKeys = Object.keys(data);
        dataKeys.forEach((key) => {
          if (data[key] !== null) {
            if (trackSettings[key]) {
              result[trackSettings[key]] = data[key];
            } else {
              result[key] = data[key];
            }
          }
        });
      }
      return result;
    },
  },
};
</script>
